import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import Gallery from './Gallery';

export default class ArticleModSideBySide extends Component {
	
    render () {
	
	    let block = this.props.block;
	    
	    let gridClass = 'l-grid';
		
		let colClass = 'l-grid__col';
		let innerColClass = 'l-grid__col__inner';
		
		if (block.width === 'edge-to-edge') {
			innerColClass = innerColClass + ' l-grid__col__inner--bust-out-left l-grid__col__inner--bust-out-right';
		} else if (block.width === 'wide') {
			colClass = colClass + ' l-grid__col--m-10-12 l-grid__col--l-8-12';
			if (block.alignment === 'center') {
				colClass = colClass + ' l-grid__col--m-push-1-12 l-grid__col--l-push-2-12';
			} else if (block.alignment === 'right') {
				colClass = colClass + ' l-grid__col--m-push-2-12 l-grid__col--l-push-4-12';
			} else if (block.alignment === 'left-no-margin') {
				innerColClass = innerColClass + ' l-grid__col__inner--bust-out-left';
			} else if (block.alignment === 'right-no-margin') {
				colClass = colClass + ' l-grid__col--m-push-2-12 l-grid__col--l-push-4-12';
				innerColClass = innerColClass + ' l-grid__col__inner--bust-out-right';
			}
		} else if (block.width == 'normal') {
			colClass = colClass + ' l-grid__col--m-8-12 l-grid__col--l-6-12';
			if (block.alignment === 'center') {
				colClass = colClass + ' l-grid__col--m-push-2-12 l-grid__col--l-push-3-12';
			} else if (block.alignment === 'right') {
				colClass = colClass + ' l-grid__col--m-push-4-12 l-grid__col--l-push-6-12';
			} else if (block.alignment === 'left-no-margin') {
				innerColClass = innerColClass + ' l-grid__col__inner--bust-out-left';
			} else if (block.alignment === 'right-no-margin') {
				colClass = colClass + ' l-grid__col--m-push-4-12 l-grid__col--l-push-6-12';
				innerColClass = innerColClass + ' l-grid__col__inner--bust-out-right';
			}
		}
		
	    return (
	        <div colClass="l-block l-block--article-media">
	        	
	        	<div className={gridClass}>
	
					<div className={colClass}>
					
						<div className={innerColClass}>
						
							<div className={'c-side-by-side c-side-by-side--' + block.vertical_alignment}>
							
								<div className="c-side-by-side__col">
						
									<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
									
										{block.left_gallery &&
											
											<Gallery slides={block.left_gallery} show_controls={true} auto_change={true} interval={4000} aspectratio={block.left_gallery_dimensions} has_caption={block.left_has_caption} />
										
										}
									
									</ScrollAnimation>
									
								</div>
								
								<div className="c-side-by-side__col">
						
									<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
									
										{block.right_gallery &&
											
											<Gallery slides={block.right_gallery} show_controls={true} auto_change={true} interval={4000} aspectratio={block.right_gallery_dimensions} has_caption={block.right_has_caption} />
										
										}
									
									</ScrollAnimation>
									
								</div>
								
							</div>
						
						</div>
						
					</div>
					
				</div>
				
			</div>
		)
	}
}